/* GEL – blog → product attribution.
   1. On blog posts: sends a GA4 select_item event when a product card is clicked.
   2. On product pages reached from a card (?gel_src=blog-<handle>): stores the source and writes it
      to the cart as the "Blog source" attribute, so it appears on the order in Shopify admin.
      The source is kept for 7 days in this browser, so later add-to-carts still count. */
(function () {
  var KEY = 'gelBlogSource', DAYS = 7;

  function remember(src) {
    try { localStorage.setItem(KEY, JSON.stringify({ src: src, t: Date.now() })); } catch (e) {}
  }
  function recall() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (v && Date.now() - v.t < DAYS * 864e5) return v.src;
    } catch (e) {}
    return null;
  }
  function setCartAttribute(src) {
    if (!src || !window.fetch) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'Blog source': src } })
    }).catch(function () {});
  }

  // 1. Card clicks on blog posts → GA4
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.gel-article-products__link');
    if (!a) return;
    var wrap = a.closest('.gel-article-products');
    var listId = 'blog_' + (wrap ? wrap.getAttribute('data-gel-article') : '');
    var listName = 'Blog: ' + (wrap ? wrap.getAttribute('data-gel-article-title') : '');
    var item = {
      item_id: a.getAttribute('data-gel-item-id'),
      item_name: a.getAttribute('data-gel-item-name'),
      item_brand: a.getAttribute('data-gel-item-brand'),
      price: parseFloat(a.getAttribute('data-gel-item-price')) || undefined,
      item_list_id: listId,
      item_list_name: listName
    };
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'select_item', { item_list_id: listId, item_list_name: listName, items: [item] });
    } else if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: 'select_item', ecommerce: { item_list_id: listId, item_list_name: listName, items: [item] } });
    }
  });

  // 2. Product pages: capture ?gel_src and keep it on the cart
  var params = new URLSearchParams(window.location.search);
  var src = params.get('gel_src');
  if (src && /^blog-[a-z0-9-]+$/.test(src)) remember(src);
  var active = src || recall();
  if (active && /\/products\//.test(window.location.pathname)) {
    setCartAttribute(active);
    document.addEventListener('submit', function (e) {
      if (e.target && /\/cart\/add/.test(e.target.getAttribute('action') || '')) setTimeout(function () { setCartAttribute(active); }, 800);
    }, true);
  }
})();
